<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <FormItem
        rules="required"
        :label="$t('advancedRevision.wizard.errorType')"
      >
        <el-radio-group
          v-model="form.errorType"
          class="horizontal-full-width"
        >
          <el-radio
            v-for="type in errorTypes"
            :key="type"
            :label="type"
          >
            {{ $t(`advancedRevision.wizard.errorTypes.${type}`) }}
          </el-radio>
        </el-radio-group>
      </FormItem>
    </el-col>
    <el-col :span="24">
      <FormItem
        rules="required"
        :label="$t('advancedRevision.wizard.errorNotes')"
      >
        <el-input
          v-model="form.errorNotes"
          type="textarea"
          :rows="3"
        />
      </FormItem>
    </el-col>
    <el-col :span="24">
      <FormItem
        rules="required"
        :label="$t('advancedRevision.wizard.internalNotes')"
      >
        <el-input
          v-model="form.internalNotes"
          type="textarea"
          :rows="3"
        />
      </FormItem>
    </el-col>
  </el-row>
</template>

<script>
  import FormItem from '@/components/FormItem.vue';

  export default {
    name: 'RevisionReasonStep',
    components: { FormItem },
    props: {
      form: { type: Object, required: true },
      errorTypes: { type: Array, required: true },
    },
  };
</script>
<style scoped>
  .horizontal-full-width {
    display: flex;
    width: 100%;
    gap: 16px;
  }

  .horizontal-full-width .el-radio {
    flex: 1;
    margin-right: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
</style>
